import React from 'react';
import { IMG_NODOC } from '@common/Assets/images';
import { SearchResultStyled } from './SearchResultStyled';
import CommonSpaceHolder from '@common/Component/CommonSpaceHolder/CommonSpaceHolder';
import { useEffect } from 'react';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from '@common/i18n';

const NoResultfound = ({facetResponse}) => {
  const searchReducer = useSelector((state) => state?.app?.searchReducer?.searchobj?.searchobj);
  const router = useRouter();
  const t = useTranslation();

  let myasterCat = '';
  if(router?.pathname?.includes('online-pharmacy')) {
    myasterCat = 'epharmacy';
  } else if(router?.pathname?.includes('doctor-consultation')) {
    myasterCat = 'doctor consult';
  } else if(router?.pathname?.includes('home-care')) {
    myasterCat = 'homecare';
  }
  useEffect(() => {
    if(searchReducer) {
      dataLayerSendEvent('search_no_result_found', {
        screen_name: "no results found",
        page_type: "no results found page",
        page_id: '',
        myaster_category: searchReducer?.myAsterCat,
        search_term: router?.query?.text || router?.query?.q || router?.query?.search,
        search_action_type: searchReducer?.searchActionType,
        referrer_page: "no results found",
        num_of_keyword_redirection: searchReducer?.numOfKeywordRedirects,
      });
      sendEventToSmartLook('search_no_result_found', searchReducer?.searchTerm);
    } else {
      dataLayerSendEvent('search_no_result_found', {
        screen_name: "no results found",
        page_type: "no results found page",
        page_id: '',
        myaster_category: myasterCat,
        search_term: router?.query?.text || router?.query?.q || router?.query?.search,
        search_action_type: 'direct landing',
        referrer_page: "no results found",
        num_of_keyword_redirection: facetResponse?.didYouMeanData?.length,
      });
    }
}, [router?.query, searchReducer]);

  return(
    <SearchResultStyled>
      <CommonSpaceHolder
        icon={IMG_NODOC}
        title={t('Search.noResultsFound')}
        subtitle={facetResponse ? "" : t('Search.noResultsFoundDesc')}
        outerCustomClass={facetResponse ? "" : "my-3 no-background"}
       />
    </SearchResultStyled>
  );
};

export default NoResultfound;
